'use client';

import '@ui5/webcomponents/dist/Toast.js';
import { ToastPlacement } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Toast` is a small, non-disruptive popup for success or information messages that disappears automatically after a few seconds.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Toast)
 */
const Toast = withWebComponent('ui5-toast', ['duration', 'placement'], [], [], []);
Toast.displayName = 'Toast';
Toast.defaultProps = {
  duration: 3000,
  placement: ToastPlacement.BottomCenter
};
export { Toast };